import React, { useState, useEffect } from 'react';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { CardElement, IbanElement } from '@stripe/react-stripe-js';
import PropTypes from 'prop-types';
import styles from './ActivationPayment.module.scss';
import RadioGroup from '../../common/RadioGroup';
import Radio from '../../common/Radio';
import Button from '../../common/Button/Button';

function ActivationPayment(props) {
  const { supplierData, alertError } = props;

  let [paymentMethod, setPaymentMethod] = useState('card');
  let [mode, setMode] = useState('read');

  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    if (supplierData.stripe_data === null) {
      setMode('edit');
    }
  }, [supplierData]);

  const handleSubmitCard = (e) => {
    const supplierId = supplierData.supplier.id;

    e.preventDefault();
    if (stripe) {
      const cardElement = elements.getElement(CardElement);

      stripe.createToken(cardElement).then((payload) => {
        if (payload.error) {
          alertError(payload.error);
        } else {
          props.update({
            supplier_id: supplierId,
            token: payload.token,
          });
        }
      });
    } else {
      console.log("Stripe.js hasn't loaded yet.");
    }
  };

  const handleSubmitIBAN = (e) => {
    const supplierId = supplierData.supplier.id;
    const { name, email } = e.target;

    e.preventDefault();

    if (stripe) {
      const ibanElement = elements.getElement(IbanElement);

      stripe
        .createSource(ibanElement, {
          type: 'sepa_debit',
          currency: 'eur',
          owner: {
            name: name.value,
            email: email.value,
          },
          mandate: {
            notification_method: 'email',
          },
        })
        .then((payload) => {
          if (payload.error) {
            alertError(payload.error);
          } else {
            props.update({
              supplier_id: supplierId,
              token: payload.source,
            });
          }
        });
    } else {
      console.log("Stripe.js hasn't loaded yet.");
    }
  };

  if (!supplierData) {
    return null;
  }

  const stripeData = supplierData.stripe_data;

  let last4 = null,
    brand = null,
    brandIcon = '',
    name = '',
    email = '';
  let isCard = true;

  if (stripeData) {
    if (stripeData.card) {
      const card = stripeData.card;

      isCard = true;
      last4 = card.last4;
      brand = card.brand;

      switch (brand.toUpperCase()) {
        case 'VISA':
          brandIcon = 'ic-visa';
          break;

        case 'MASTER-CARD':
          brandIcon = 'ic-mastercard';
          break;

        default:
      }
    } else if (stripeData.sepa_debit) {
      isCard = false;
      name = stripeData.owner.name;
      email = stripeData.owner.email;
      last4 = stripeData.sepa_debit.last4;
    }
  }

  return (
    <div className={styles.container}>
      {mode === 'read' ? (
        <div className={styles.readMode}>
          {isCard ? (
            last4 && brand ? (
              <div className={styles.body}>
                <h4>CREDIT CARD</h4>
                <span className={brandIcon}>
                  <span className="path1" />
                  <span className="path2" />
                </span>
                <span>
                  {brand} XXXX-XXXX-XXXX-{last4}
                </span>
                <button className={styles.change_card_button} onClick={() => setMode('edit')}>
                  Change
                </button>
              </div>
            ) : null
          ) : (
            <div className={styles.body}>
              <h4>Bank Transfer</h4>
              <span>{name}</span>
              <span>{email}</span>
              <span>X-{last4}</span>
              <button className={styles.change_card_button} onClick={() => setMode('edit')}>
                Change
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className={styles.editMode}>
          <RadioGroup name="paymentMethod" selectedvalue={paymentMethod} onChange={setPaymentMethod} column>
            <Radio id="methodCard" value="card" label="Credit Card" />

            {paymentMethod === 'card' ? (
              <form onSubmit={handleSubmitCard}>
                <label>
                  Card details
                  <CardElement />
                </label>
                <Button type="submit" text="SUBMIT CARD" />
                <Button onClick={() => setMode('read')} color="white" text="Cancel" />
              </form>
            ) : null}

            <Radio id="methodIBAN" value="iban" label="Bank Transfer" />

            {paymentMethod === 'iban' ? (
              <form onSubmit={handleSubmitIBAN}>
                <label>
                  Name
                  <input name="name" type="text" placeholder="Jane Doe" required />
                </label>

                <label>
                  Email
                  <input name="email" type="email" placeholder="jane.doe@example.com" required />
                </label>

                <label>
                  IBAN
                  <IbanElement options={{ supportedCountries: ['SEPA'] }} />
                </label>

                <Button type="submit" text="SUBMIT IBAN" />

                <Button onClick={() => setMode('read')} color="white" text="Cancel" />
              </form>
            ) : null}
          </RadioGroup>
        </div>
      )}
    </div>
  );
}

export default ActivationPayment;

ActivationPayment.propTypes = {
  supplierData: PropTypes.object.isRequired,
  update: PropTypes.func.isRequired,
  alertError: PropTypes.func.isRequired,
};
